import axiosServices from "../utils/axios";

export const addPortCallNotification= async (data:  { agentOnly: boolean; hqOnly: boolean; email_introduction: string; pcid: string, attachmentList:any, includeCC:boolean}) => {
  const response = await axiosServices.post(`/reports/portcallnotification`, data);
  return (response);
};

export const getPortCallNotification = async (params: { agentOnly: boolean; pcid: string; hqOnly: boolean; showCompletedBerth: boolean; version?: "v1" | "v2" | "final" }) => {
  const { agentOnly, pcid, hqOnly, showCompletedBerth, version = "v1" } = params;
  const endpoint = version === "v2" ? "portcallnotification-v2" : "portcallnotification";
  let url=`/email/${endpoint}?agentOnly=${agentOnly}&pcid=${pcid}&hqOnly=${hqOnly}`;
  if(showCompletedBerth){
    url+=`&showCompletedBerth=${showCompletedBerth}`;
  }
  const response = await axiosServices.get(`${url}`);
  return response;
};

export type FinalPortLogWarningCode =
  | "attachment_too_large"
  | "no_completed_sofs"
  | "csofdocs_query_failed"
  | "ai_generation_failed"
  | "operational_summary_failed"
  | "malformed_rotation_timestamp_etd"
  | "malformed_rotation_timestamp_eta";

export interface FinalPortLogRecipient {
  name: string;
  email: string;
}

export interface FinalPortLogAttachment {
  documentId: string;
  fileName: string;
  mimeType: string;
  size: number;
  groupKey?: string;
}

export interface FinalPortLogResponse {
  subject: string;
  html: string;
  recipients: {
    to: FinalPortLogRecipient[];
    cc: FinalPortLogRecipient[];
  };
  attachments: FinalPortLogAttachment[];
  warnings: (FinalPortLogWarningCode | string)[];
}

/**
 * Fetches the Final Port Log email preview for a completed voyage.
 * GET /email/finalportlog?jobId={jobId}
 * Returns subject/html/recipients pre-populated for the Outlook composer,
 * plus a non-fatal warnings[] array (see FinalPortLogWarningCode) covering
 * partial data — AI summary failure, missing PETS, oversized SOF bundle, etc.
 * None of these warnings should block composing or sending.
 */
export const fetchFinalPortLog = async (jobId: string): Promise<FinalPortLogResponse> => {
  const { data } = await axiosServices.get(`/email/finalportlog`, { params: { jobId } });
  return data;
};

